import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importPayrollConnectionIntro = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "PayrollConnectionIntroScreen" */
                '@perpay-web/fintech/components/screens/PayrollConnectionIntroScreen/PayrollConnectionIntroScreen'
            ),
    );
